import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/technologies/skincare-ar"
    exact
    path="/business/technologies/skincare-ar"
    component={AsyncPage}
    backgroundImage={require('../../../../assets/images/consumer/technologies/background.jpg')}
  />,
];
